import React, { ErrorInfo, PropsWithChildren } from 'react';
import { Modal } from '@routific/hive';
import ErrorBody from './ErrorBody';
import { reportBoundaryError } from './reportBoundaryError';

class ErrorOverlay extends React.Component<PropsWithChildren, { error: Error | null }> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error: error.message,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportBoundaryError(error, errorInfo);
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;
    return (
      <>
        {error
      && (
      <Modal
        visible
        mask
        centered
        closable={false}
        maskClosable={false}
        footer={null}
        style={{ maxWidth: 800 }}
        size="large"
        bodyStyle={{ padding: '1rem' }}
      >
        <ErrorBody />
      </Modal>
      )}
        {children}
      </>
    );
  }
}

export default ErrorOverlay;
